// src/utils/paymentMethodIcons.js
import { Check, X } from 'lucide-react';

const DEFAULT_ICON_WIDTH = 56;
const DEFAULT_ICON_HEIGHT = 'auto';

export const getPaymentMethodIconUrl = (iconFileName) => {
  return iconFileName ? `/assets/payment-methods-icon/${iconFileName}` : null;
};

// label is used for accessibility (alt/title) since the icon replaces the text label.
// `verified` is optional: pass true/false to render a small tick/cross badge on the
// top-left corner of the icon indicating whether the payment has been verified.
// Leave it undefined to render the icon with no badge.
export const PaymentMethodIcon = ({
  iconFileName,
  label,
  className,
  width = DEFAULT_ICON_WIDTH,
  height = DEFAULT_ICON_HEIGHT,
  verified
}) => {
  const src = getPaymentMethodIconUrl(iconFileName);
  if (!src) return null;

  const badgeTitle = verified
    ? `${label ? `${label} — ` : ''}Payment verified`
    : `${label ? `${label} — ` : ''}Payment not verified`;

  return (
    <span
      className={className}
      style={{ position: 'relative', display: 'inline-flex', lineHeight: 0 }}
    >
      <img
        src={src}
        alt={label || ''}
        title={label || ''}
        loading="lazy"
        style={{ width, height, objectFit: 'fill' }}
      />
      {verified !== undefined && (
        <span
          title={badgeTitle}
          style={{
            position: 'absolute',
            top: -2,
            left: -2,
            width: 10,
            height: 10,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: verified ? '#16a34a' : '#dc2626',
            boxShadow: '0 0 0 1.5px var(--color-bg-primary, #fff)'
          }}
        >
          {verified ? (
            <Check size={7} color="#fff" strokeWidth={4} />
          ) : (
            <X size={7} color="#fff" strokeWidth={4} />
          )}
        </span>
      )}
    </span>
  );
};
